var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme, { marks, strMark } from 'Theme';
import { t } from 'helpers/i18n';
import History from 'helpers/History';
import { sections } from 'scenes/Main';
import { Button, Icon } from 'elements';
import QueryParams from './QueryParams';
var NavBar = /** @class */ (function (_super) {
    __extends(NavBar, _super);
    function NavBar(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.state = {
            selectedSection: undefined,
            activePath: undefined
        };
        _this.handleSection = function (selectedSection) { return function () {
            _this.setState({ selectedSection: selectedSection });
            if (selectedSection)
                _this.handleLink(selectedSection.links[0].path)();
        }; };
        _this.handleLink = function (activePath) { return function () {
            _this.setState({ activePath: activePath });
            History.push(activePath);
        }; };
        var currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
        var isCivitrip = ((_a = _this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        var selectedSection = currentPath
            ? sections(props.store.users.user, isCivitrip).find(function (section) {
                return section.links.find(function (link) { return link.path.indexOf(currentPath) > -1; })
                    ? true
                    : false;
            })
            : undefined;
        _this.state.selectedSection = selectedSection;
        _this.state.activePath = currentPath;
        return _this;
    }
    NavBar.prototype.render = function () {
        var _this = this;
        var _a;
        var selectedSection = this.state.selectedSection;
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        return (React.createElement(Wrapper, null,
            selectedSection ? (React.createElement(Button, { onClick: this.handleSection() },
                React.createElement(Icon, { name: "back" }))) : null,
            !selectedSection
                ? sections(this.props.store.users.user, isCivitrip).map(function (section) { return (React.createElement(StyledButton, { key: section.name, onClick: _this.handleSection(section) }, t(section.name))); })
                : selectedSection.links.map(function (link) { return (React.createElement(StyledButton, { key: link.name, primary: isActive(link.path), onClick: _this.handleLink(link.path) }, t(link.name))); })));
    };
    NavBar = __decorate([
        inject('store')
    ], NavBar);
    return NavBar;
}(Component));
export default QueryParams(NavBar);
var Wrapper = cxs('div')({
    display: 'flex',
    height: Theme.size.bar,
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    backgroundColor: Theme.color.background
});
var StyledButton = cxs(Button)({
    flex: 1
});
var pathRegex = /\/(\w*)/;
// const pathRegex = /\/.*?\/(\w*)/
var isActive = function (_path) {
    var currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
    var path = (pathRegex.exec(_path) || [])[1];
    return currentPath === path;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar.tsx
// module id = 1041
// module chunks = 0